var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllCapsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3481 8.44287L7.10804 20.7539H5.57755L9.39565 7.24609H10.3563L10.3481 8.44287ZM12.9695 20.7539L9.72943 8.44287L9.71314 7.24609H10.6819L14.5 20.7539H12.9695ZM12.9695 15.7534V17.2192H7.25458V15.7534H12.9695Z",
    fill: "#B4B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2706 8.44287L15.0305 20.7539H13.5L17.3181 7.24609H18.2787L18.2706 8.44287ZM20.892 20.7539L17.6519 8.44287L17.6356 7.24609H18.6044L22.4225 20.7539H20.892ZM20.892 15.7534V17.2192H15.1771V15.7534H20.892Z",
    fill: "#B4B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCapsIcon);
export default __webpack_public_path__ + "static/media/AllCapsIcon.184bfe886388258d5b71e72ac928ca75.svg";
export { ForwardRef as ReactComponent };